<template>
  <div class="c-tab">
    <ul class="c-tab__container">
      <f-tab-item
        v-for="(item, index) in items"
        :item="item"
        :key="index"
        @tab-item-clicked="onTabItemClicked(index)"
      ></f-tab-item>
    </ul>
  </div>
</template>

<script>
import FTabItem from '~/js/components/tab/item'

export default {
  name: 'ComponentTab',
  props: {
    items: { type: Array },
  },
  components: { FTabItem },
  methods: {
    onTabItemClicked(index) {
      this.$emit('tab-item-clicked', index)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-tab {
  margin: 0 -24px;
  overflow-y: scroll;
  padding: 0 24px 15px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: variables.$width-section) {
    margin: 0 calc(-1 * (50vw - variables.$width-section/2 + 24px));
  }

  &__container {
    background-color: variables.$color-gray;
    border-radius: 50px;
    display: inline-flex;
    padding: 7px 8px;

    @include mixins.screen-mobile {
      width: auto;
      justify-content: space-between;
    }

    @media screen and (min-width: variables.$width-section) {
      margin-left: calc(50vw - variables.$width-section/2);
    }
  }
}
</style>
